





import Vue, { PropType } from 'vue'
import IconButton from '~/components/IconButton.vue'
import { formatDate } from '~/utils/functions'
import { GetTopUpDTO } from '~/utils/interfaces/topup.interface'

export default Vue.extend({
  components: { IconButton },
  props: {
    item: {
      type: Object as PropType<GetTopUpDTO>,
      required: true,
    },
  },
  methods: {
    async onClick() {
      const html = `
        <h2 style="text-align: center;">
            Comprobante de recarga
        </h2>
        <table class="mx-auto">
            <tbody>
                <tr>
                    <td>
                        ${this.$t('date')}
                    </td>
                    <td class="text-right">
                        ${formatDate(this.item.created_at)} 
                    </td>
                </tr>
                <tr>
                    <td>
                        ${this.$t('number')}
                    </td>
                    <td class="text-right">
                        ${this.item.phone_number ||
                          this.item.destination_account}
                    </td>
                </tr>
                <tr>
                    <td>
                        ${this.$t('code')} 
                    </td>
                    <td class="text-right">
                        ${this.item.code}
                    </td>
                </tr>
                <tr>
                    <td>
                        ${this.$t('status')} 
                    </td>
                    <td class="text-right">
                        ${this.$t(this.item.status)}
                    </td>
                </tr>
                <tr>
                    <td>
                        ${this.$t('carrier_trans_id')} 
                    </td>
                    <td class="text-right">
                        ${this.$t(this.item.carrier_trans_id)}
                    </td>
                </tr>
                <tr>
                    <td>
                        ${this.$t('trans_id')}
                    </td>
                    <td class="text-right">
                        ${this.$t(this.item.trans_id)}
                    </td>
                </tr>
            </tbody>
        </table>
        <h4 style="text-align: center;">
           Gracias por elegirnos
        </h4>
      `
      const newFrame = document.createElement('iframe')
      newFrame.style.visibility = 'hidden'
      newFrame.id = 'printf'
      document.body.append(newFrame)
      const frame = newFrame.contentDocument || newFrame.contentWindow?.document
      if (!frame) return
      frame.head.innerHTML = `
        <style>
            .text-right {
                text-align: right;
            }
            .mx-auto {
                margin-left: auto; margin-right: auto;
            }
            td {
                padding-left: 4px;
                padding-right: 4px;
            }
            body {
                font-family: Arial;
            }
        </style>
      `
      frame.body.innerHTML = html
      frame.body
      //   console.log(document.getElementById('printf'))
      const iframe = document.getElementById('printf') as HTMLIFrameElement
      iframe.contentWindow?.focus()
      setTimeout(() => {
        console.log(iframe)
        iframe.contentWindow?.print()
      }, 2000)
    },
  },
})
